import React, {useEffect, useState} from 'react';
import {Alert, Button, Checkbox, TextField} from "@mui/material";
import Card from "../../common/card/Card";
import styles from "./UserSettingsUpdate.module.scss";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {getSelectedHasOfferUser, updateHasOfferUserSettings} from "../../services/usersService";
import {AppCategories} from "../../utils/hasOfferCategories";

const initState = {
    user_id:0,
    firstname: '',
    lastname: '',
    phone: '',
    city: '',
    website: '',
    categories: []
}



const UserSettingsUpdate = () => {
    const {t} = useTranslation();
    const [formData, setFormData] = useState(initState);
    const [searchParams] = useSearchParams();
    const [categoriesMap, setCategoriesMap] = useState({});
    const [hideForm,setHideForm] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const isCategorySelected = (key) => {
        return !!categoriesMap[key];
    };
    const getHasofferUserDetails = async (email) => {
        const response = await getSelectedHasOfferUser(email);
        if (!!response.data && !!response.data.user) {
            let map = {};
            const responseFormData = response.data.user;
            const categoriesResponse = JSON.parse(responseFormData.categories);
            const resultFormData = {
                user_id:responseFormData.hasoffersid,
                firstname: responseFormData.firstname,
                lastname: responseFormData.lastname,
                phone: responseFormData.phone,
                city: responseFormData.city,
                website: responseFormData.website,
                categories: categoriesResponse
            }
            Object.keys(AppCategories).forEach(key => {
                const value = AppCategories[key].en;
                const isExist = !!categoriesResponse.find(category => category.trim() === value);
                map[key] = isExist;
            });
            setCategoriesMap(map);
            setFormData(resultFormData);
        }else{
            setHideForm(true);
        }
    }

    useEffect(() => {
        const email = searchParams.get("email");
        if (!!email) getHasofferUserDetails(email);
    }, [searchParams])

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }))
    }
    const handleCategoryChange = (key) => {
        let currentState = categoriesMap[key];
        setCategoriesMap((prevState)=>({
            ...prevState,
            [key]:!currentState
        }));
        const value = AppCategories[key].en;
        if(!!currentState){
            let copyArr = formData.categories.map(category => category.trim());
            const index = copyArr.indexOf(value);
            if(index > -1){
                copyArr.splice(index,1);
            }
            setFormData((prevState)=>({
                ...prevState,
                categories: copyArr
            }))
        }else{
            let addArr = [...formData.categories];
            addArr.push(value);
            setFormData((prevState)=>({
                ...prevState,
                categories: addArr
            }))
        }
    }

    const updateHandler = async (e) => {
        const response = await updateHasOfferUserSettings(formData);
        if(response.data.isUpdated){
            setFormData(initState);
            setShowResult(true);
        }
    }
    return (
        <div className={styles.container}>

            {!hideForm && !showResult && <Card title={t("common-tr.update-user-settings-msg")}>
                <div className={styles.formItself}>
                    <TextField
                        id="outlined-basic"
                        name="firstname"
                        label={t("common-tr.name")}
                        value={formData.firstname}
                        variant="outlined"
                        sx={{width: 330}}
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="outlined-basic"
                        name="lastname"
                        label={t("common-tr.surname")}
                        value={formData.lastname}
                        variant="outlined"
                        sx={{width: 330}}
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="outlined-basic"
                        name="phone"
                        label={t("common-tr.phone")}
                        value={formData.phone}
                        variant="outlined"
                        sx={{width: 330}}
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="outlined-basic"
                        name="city"
                        label={t("common-tr.city")}
                        value={formData.city}
                        variant="outlined"
                        sx={{width: 330}}
                        onChange={handleInputChange}
                    />
                    <TextField
                        id="outlined-basic"
                        name="website"
                        label={t("common-tr.social-media-account")}
                        value={formData.website}
                        variant="outlined"
                        sx={{width: 330}}
                        onChange={handleInputChange}
                    />
                    <div className={styles.categories}>
                        <div className={styles.title}>{t("common-tr.categories")}</div>
                        <div className={styles.subTitle}>{t("common-tr.categories-msg")}</div>
                        {!!formData.categories && Object.keys(categoriesMap).length > 0  && Object.keys(AppCategories).map(key => (
                            <div key={key} className={styles.checkBoxHolder}>
                                <Checkbox
                                    name={AppCategories[key].tr}
                                    checked={isCategorySelected(key)}
                                    onChange={e => handleCategoryChange(key)}
                                />
                                <div>{AppCategories[key].tr}</div>
                            </div>
                        ))}
                    </div>
                    <Button
                        variant='contained'
                        /*disabled={!password || !email}*/
                        onClick={updateHandler}
                    >
                        {t("common-tr.update")}
                    </Button>
                </div>
            </Card>}
            {hideForm && <div>Kullanıcı bulunamadı</div>}
            {showResult && <div>
                <Alert
                    severity={"info"}
                    sx={{width: '100%'}}>
                    {t("user-admin.user_details_updated_success_msg_tr")}
                </Alert>
            </div>}
        </div>
    );
};

export default UserSettingsUpdate;
